export let requestConfig = {
    apiHost: "https://api.etscscan.io",
};
